import { atom } from 'jotai';
import { atomWithStorage, RESET } from 'jotai/utils'

export const cartAtom = atomWithStorage('cart', {items: [], checkingOut: false, uuid: null});
